import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@justgiving/react-tracking';
import { useModalToggle } from '../../hooks';
import { ShareModal } from '../ShareModal/ShareModal';
import { MarkSuccessOnClick } from '../MarkSuccessOnClick/MarkSuccessOnClick';
import { Experiments } from '../../constants/experiments';

//B2C_008 - Delete successType from props once the test is complete
interface ShareProps {
  successType: string;
}

export const Share: FunctionComponent<ShareProps> = ({ successType }) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isOpen, setOpen } = useModalToggle();

  return (
    <>
      <MarkSuccessOnClick
        testSlug={Experiments.b2c_hide_sticky_bar}
        successType={successType}
      >
        <Button
          className="jg-btn jg-btn--ghost"
          onClick={() => setOpen(true)}
          type="button"
          trackingData={{
            action_name: 'click',
            subtype: 'share',
            event: 'click',
            event_value: 'share',
          }}
        >
          {t('common.share')}
        </Button>
      </MarkSuccessOnClick>
      {isOpen ? <ShareModal onClose={() => setOpen(false)} /> : null}
    </>
  );
};
